export const FeaturePanel = ({
  hasFeature,
  showErrorPanel,
  children,
}: {
  hasFeature?: boolean;
  showErrorPanel?: boolean;
  children: JSX.Element;
}) => {
  return hasFeature ? (
    children
  ) : showErrorPanel ? (
    <div>
      <h1>No permission for this feature.</h1>
    </div>
  ) : null;
};
